import { makeStyles } from '@material-ui/core';
import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import { ButtonOne } from '../ButtonOne/ButtonOne.component';

export const useStyles = makeStyles(() =>
  createStyles({
    modalTitle: {
      marginTop: '26px',
      marginLeft: '23px',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: 18,
      lineHeight: '21px',
      color: '#2C2D3E',
      marginBottom: '17px',
    },
    modalSubTitle: {
      marginLeft: '46px',
      fontFamily: 'Roboto',
      fontWeight: 700,
      fontSize: 16,
      lineHeight: '19px',
      marginBottom: '33px',
      color: '#2C2D3E',
      height: '19px',
    },
    backButton: {
      position: 'relative',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: 14,
      lineHeight: '16px',
      color: '#3C419A',
      marginBottom: '34px',
      marginLeft: '13px',
      '&:hover': {
        cursor: 'pointer',
      },
    },
    backArrowIcon: {
      position: 'relative',
      top: '7px',
    },
    errorMessage: {
      fontFamily: 'Roboto',
      color: '#BC0000',
      fontWeight: 400,
      fontSize: 14,
      marginBottom: '28px',
      marginLeft: '180px',
      marginTop: '-24px',
    },
    errorIcon: {
      height: '20px',
      width: '20px',
      position: 'relative',
      top: '6px',
    },
    leftFormInput: {
      padding: '0px',
      width: '320px',
      height: '50px',
      borderRadius: '3px',
      boxSizing: 'border-box',
      marginLeft: '46px',
      marginBottom: '26px',
      appearance: 'none',
    },
    rightFormInput: {
      padding: '0px',
      width: '320px',
      height: '50px',
      borderRadius: '3px',
      boxSizing: 'border-box',
      marginLeft: '3px',
      appearance: 'none',
    },
    accTypeInput: {
      padding: '0px',
      width: '320px',
      height: '50px',
      borderRadius: '3px',
      boxSizing: 'border-box',
      marginLeft: '3px',
      appearance: 'none',
    },
    commiteeInput: {
      padding: '0px',
      width: '320px',
      height: '50px',
      borderRadius: '3px',
      boxSizing: 'border-box',
      marginLeft: '46px',
      marginBottom: '26px',
      appearance: 'none',
    },
    menuItem: {
      '&:hover': {
        backgroundColor: '#CACAFC33',
        color: '#3C419A',
      },
    },
    editUserButton: {
      width: '147px',
      marginLeft: '530px',
      marginTop: '85px',
      padding: '0px 0px 0px 0px',
      fontSize: 14,
      height: '36px',
      left: '59px',
      border: 'solid 1px #3C419A',
      color: '#3C419A',
      backgroundColor: '#FFFFFF',
      boxShadow: 'none',
      '&:hover': {
        backgroundColor: '#FFFFFF',
      },
    },
  }),
);

export const styles = (theme: Theme) =>
  createStyles({
    root: {
      width: '768px',
      margin: 0,
      padding: 0,
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

export const CancelButton = withStyles(() => ({
  root: {
    width: '147px',
    top: '8px',
    padding: '0px',
    height: '36px',
    border: 'solid 1px #3C419A',
    color: '#3C419A',
    backgroundColor: '#FFFFFF',
    marginLeft: '385px',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#FFFFFF',
      boxShadow: '0px 3px 1px 0px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 1px rgba(0,0,0,0.12)',
    },
  },
}))(ButtonOne);

export const ConfirmButton = withStyles(() => ({
  root: {
    position: 'relative',
    top: '8px',
    width: '147px',
    padding: '0px',
    height: '36px',
    border: 'solid 1px #3C419A',
    color: '#FFFFFF',
    backgroundColor: '#3C419A',
    marginLeft: '25px',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#3C419A',
      boxShadow: '0px 3px 1px 0px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 1px rgba(0,0,0,0.12)',
    },
    '&:disabled': {
      color: '#FFFFFF',
      backgroundColor: '#2C2D3E4D',
      border: 'solid 1px #2C2D3E4D',
      cursor: 'not-allowed', 
    },
  },
}))(ButtonOne);
